import { render, staticRenderFns } from "./RetentionPolicy.vue?vue&type=template&id=518bf26c&"
import script from "./RetentionPolicy.vue?vue&type=script&lang=js&"
export * from "./RetentionPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports